//#region IMPORTS
import { InstoreBasketItem } from "../../models/instoreBasket";
//#endregion

//#region INTERFACE
interface Props {
  item: InstoreBasketItem;
}
//#endregion

export default function InstoreBasketConfirmItem({ item }: Props) {
  //#region RENDER
  return (
    <div
      key={item.template_row_id}
      className="grid grid-cols-[40px_1fr] gap-x-6 items-center px-4 py-2 text-left text-sm border-t border-b border-black even:bg-[#f2f2f2] lg:h-20 lg:text-base"
    >
      <p className="font-semibold text-lg lg:text-2xl text-right">
        {item.quantity}
      </p>
      <div className="flex flex-col">
        <p className="font-medium">{item.article_name || "—"}</p>
        <p className="text-sm text-[#254559]">
          {item.theme}
          {item.store_format ? ` · ${item.store_format}` : ""}
        </p>
      </div>
    </div>
  );
  //#endregion
}
